import { h } from "preact";
import { SlideButton } from './SlideButton';
import { SlideInfo } from "./SlideInfo";
import { CSSTransition } from 'preact-transitioning';

function SlideInfoBlock ({ 
  id,
  serviceId,
  title,
  description,
  advantages,
  isActive,
}: any) {
  // const cn = `index__wrapper-slider-slide-block ${
    // isActive ? "fade-enter-active" : "fade-exit-active"
  // }`;

  // TODO: Check why transition depends on slider nav click direction <21-06-21,22-06-21> //
  return (
    <CSSTransition
      in={isActive}
      appear
      classNames={"fade-in"}
      duration={500}
      // timeout={300}
    >
      <div className={"index__wrapper-slider-slide-block"}>
        <SlideInfo
          title={title}
          description={description}
          advantages={advantages} 
        />
        <SlideButton id={id} serviceId={serviceId} />
      </div>
    </CSSTransition>
  );
}

export { SlideInfoBlock };
